import type { StarClassId } from './ids';

export interface StarClassDef {
  id: StarClassId;
  i18nKey: `star.${StarClassId}`;
  /** Effective surface temperature, kelvin. Drives the rendered colour. */
  temperatureK: number;
  /** Luminosity relative to the Sun. Drives zone boundaries and solar energy. */
  luminositySun: number;
  /** Radius on the map in hexes (GDD §3). */
  radiusHexes: number;
  inMvp: boolean;
}

/** Approximate textbook values per spectral class (GDD §3 «Типы звёзд»). */
export const STAR_CLASSES: Readonly<Record<StarClassId, StarClassDef>> = {
  G: {
    id: 'G',
    i18nKey: 'star.G',
    temperatureK: 5800,
    luminositySun: 1,
    radiusHexes: 1,
    inMvp: true,
  },
  K: {
    id: 'K',
    i18nKey: 'star.K',
    temperatureK: 4500,
    luminositySun: 0.3,
    radiusHexes: 1,
    inMvp: false,
  },
  M: {
    id: 'M',
    i18nKey: 'star.M',
    temperatureK: 3200,
    luminositySun: 0.02,
    radiusHexes: 1,
    inMvp: false,
  },
  F: {
    id: 'F',
    i18nKey: 'star.F',
    temperatureK: 6700,
    luminositySun: 2.5,
    radiusHexes: 2,
    inMvp: false,
  },
  redGiant: {
    id: 'redGiant',
    i18nKey: 'star.redGiant',
    temperatureK: 4000,
    luminositySun: 200,
    radiusHexes: 3,
    inMvp: false,
  },
  binary: {
    id: 'binary',
    i18nKey: 'star.binary',
    temperatureK: 5500,
    luminositySun: 1.5,
    radiusHexes: 1,
    inMvp: false,
  },
};
